import { render } from "./modal-common.vue?vue&type=template&id=b15de4c6&scoped=true"
import script from "./modal-common.vue?vue&type=script&lang=js"
export * from "./modal-common.vue?vue&type=script&lang=js"

import "./modal-common.vue?vue&type=style&index=0&id=b15de4c6&scoped=true&lang=css"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15de4c6"]])

export default __exports__